import { Card, CardActionArea, CardHeader } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Avatar from "../common/Avatar";
import { CatalogItem } from "../../app/backendTypes";
import { useContract } from "../../app/hooks";

export default function CatalogCard(props: { catalog: CatalogItem }) {
  const { catalog } = props;

  const { contract } = useContract(catalog.contract_id?.toString());

  return (
    <Card>
      <CardActionArea component={RouterLink} to={`/catalog/${catalog.id}`}>
        <CardHeader
          title={catalog.info.display_name || contract?.name}
          subheader={catalog.info.short_desc || contract?.short_desc}
          avatar={
            <Avatar
              alt={catalog.info.display_name || contract?.name || ""}
              src={catalog.info.avatar || contract?.avatar}
            />
          }
        />
      </CardActionArea>
    </Card>
  );
}
